function captureDefaultInputEvent(event) {
    const aft = window['aladdinFrontendTelemetry'];
    if (aft && aft.captureBXFInputEvent) {
        aft.captureBXFInputEvent(event);
    }
}

export { captureDefaultInputEvent as c };
